require '../helpers/rate_settings_helper'

$(document).ready ->
  settingsView = Extranet.Helpers.RateSettings.getRateSettingsView()
